import { injectable } from 'inversify';
import { SessionStorageService, StorageService } from '../../../platform/StorageService';
import { resolve } from '../../Container';

@injectable()
export class PropertyHistory {

    @resolve(SessionStorageService) private sessionData!: StorageService;

    // public get(typeName: string, propertyName: string): any {
    //     return this.sessionData.get(`deqo/ui/${typeName}.${propertyName}`) ?? null;
    // }

    // public set(typeName: string, propertyName: string, value: any) {
    //     return this.sessionData.put(`deqo/ui/${typeName}.${propertyName}`, value);
    // }
}
